import { Button } from "components/UI/Button";
import { CustomToggle, TOGGLE_SIZE } from "components/UI/CustomToggle";
import { InfoCircle, Plus } from "components/UI/Icons";
import { Tooltip } from "components/UI/Tooltip";
import { TooltipContent } from "components/UI/Tooltip/TooltipContent";
import { useAppDispatch } from "hooks/useAppDispatch";
import { useAppSelector } from "hooks/useAppSelector";
import { useTranslation } from "localization/localization";
import { addCargoRow, selectGroupById, toggleUsePallets } from "store";
import { CargoGroupProps } from "./CargoGroup.types";
import { CargoEmpty } from "../CargoEmpty";
import { CargoTable } from "./CargoTable";
import { GroupHeader } from "./GroupHeader";
import { PalletTable } from "./PalletTable";
import s from "./CargoGroup.module.scss";

export const CargoGroup = ({ groupId, onImport }: CargoGroupProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const group = useAppSelector(selectGroupById(groupId));

  if (!group) return null;

  const hasRows = group.cargoRows.length > 0;

  return (
    <div className={s.wrapper}>
      <GroupHeader groupId={groupId} />

      {hasRows ? (
        <>
          <CargoTable groupId={groupId} />

          <div className={s.actions}>
            <Button className={s.btn} onClick={() => dispatch(addCargoRow(groupId))}>
              <Plus /> {t("Add cargo")}
            </Button>

            <div className={s.pallets}>
              <CustomToggle
                className={s.toggle}
                size={TOGGLE_SIZE.S}
                label={t("Use pallets for group")}
                checked={group.usePallets}
                onChange={() => dispatch(toggleUsePallets(groupId))}
              />

              <Tooltip
                triggerElement={<InfoCircle className={s.infoCircle} />}
                offsetY={8}
                placement="top"
                enabledOnMobile={true}
              >
                <TooltipContent className={s.tooltipContent}>
                  {t("Palletized cargo is easy to move and provides additional stability and safety of the cargo.")}
                </TooltipContent>
              </Tooltip>
            </div>
          </div>

          {group.usePallets && <PalletTable groupId={groupId} />}
        </>
      ) : (
        <CargoEmpty groupId={groupId} onImport={onImport} />
      )}
    </div>
  );
};
